const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const fetchExport = async (format) => {
  const token = localStorage.getItem('@mybank:token');
  const response = await fetch(`${API_URL}/reports/export?format=${format}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.error?.message || `Erro ao exportar (${response.status})`);
  }

  return response;
};

export const exportService = {
  exportCSV: async () => {
    const today = new Date().toISOString().split('T')[0];
    const response = await fetchExport('csv');
    const blob = await response.blob();
    triggerDownload(blob, `mybank-transacoes-${today}.csv`);
  },

  exportJSON: async () => {
    const today = new Date().toISOString().split('T')[0];
    const response = await fetchExport('json');
    const blob = await response.blob();
    triggerDownload(blob, `mybank-backup-${today}.json`);
  },
};

export default exportService;
